// extracted by mini-css-extract-plugin
export default {"sidebarBack":"sidebarBack-wKKG4"};